// extracted by mini-css-extract-plugin
export default {"nextButton":"StepFooterButton_nextButton__Gh9TB","optIn":"StepFooterButton_optIn__mqkwI"};